module.exports = __webpack_public_path__ + "static/media/provinceimg.220b08fe.png";